import { render } from "./ShutdownBanner.vue?vue&type=template&id=0abd423a&scoped=true&ts=true"
import script from "./ShutdownBanner.vue?vue&type=script&lang=ts"
export * from "./ShutdownBanner.vue?vue&type=script&lang=ts"

import "./ShutdownBanner.vue?vue&type=style&index=0&id=0abd423a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0abd423a"]])

export default __exports__